import { useState } from "react";
import { Col } from "react-bootstrap";

export default function Clock({ time }) {
  const [hidden, setHidden] = useState(false);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
    const seconds = time % 60
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  }

  return (
    <Col
      xs={12}
      lg={6}
      className='d-flex justify-content-center align-items-center'
      style={{ cursor: 'pointer' }}
      onClick={() => setHidden((prev) => !prev)}
    >
      {hidden ? (
        <i className="bi bi-eye-slash" style={{ fontSize: '5rem', margin: 0 }}></i>
      ) : (
        <p className='clock' style={{ fontSize: '5rem', margin: 0 }}>
          {formatTime(time)}
        </p>
      )}
    </Col>
  );
}